import { types } from "./types";
import { mainCategoryOptions as allCategories, lawTypeOptions as allTypes } from "../../data/data";

const initialState = {
  // laws: [],
  // lawCategories: [],
  // lawTypes: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LAWS.SUCCESS:
      const filteredCategories = allCategories.filter(item =>
        action.payload.some(law => law?.mainCategory === item?.value)
      );
      const filteredTypes = allTypes.filter(item =>
        action.payload.some(law => law?.type === item?.value)
      );
      return {
        ...state,
        laws: action.payload,
        lawCategories: filteredCategories,
        lawTypes: filteredTypes
      };
    case types.CREATE_LAW.SUCCESS:
      return {
        ...state,
        laws: [action.payload, ...state.laws]
      };
    case types.CHECK_LAW.SUCCESS:
      return {
        ...state,
        status: action.payload,
      };
    case types.UPDATE_LAW.SUCCESS:
      return state;
    case types.DELETE_LAW.SUCCESS:
      return {
        ...state,
        laws: state.laws?.filter(l => l._id !== action.payload._id)
      };
    default:
      return state;
  }
}

export default reducer;
